import { useLocale } from '@hooks/useLocale';
import { useTranslation } from 'next-i18next';
import AlertInlineMessage from '@components/ui/AlertInlineMessage';
import Button from '@components/ui/Button';
import Heading from '@components/ui/Heading';
import { isWithinDateRangePST } from '@utils/dateAndTime/isBetween';

import styles from './ProductPromotionMessaging.module.scss';

export const promotionEarningAmounts = [
  { spendAmount: 200, receiveAmount: 30 },
  { spendAmount: 400, receiveAmount: 80 },
  { spendAmount: 600, receiveAmount: 150 },
];

export const promotionURL = (locale?: string) =>
  locale !== 'fr'
    ? '/en/explore/spend-and-get-faq'
    : '/fr/explore/depensez-et-obtenez-la-faq';

const PromotionMessaging = ({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}) => {
  const { t } = useTranslation('pdp');
  const locale = useLocale();
  if (!isWithinDateRangePST(startDate, endDate)) {
    return null;
  }

  return (
    <AlertInlineMessage
      messageType="INFORMATION"
      classNames={styles.itemAlert}
      key={'promotion-alert'}
      customIcon="giftcard"
      customIconHeight={24}
      customIconWidth={24}
    >
      <Heading styleLevel="7" semanticLevel="h2">
        {t('product.pdp.promotion.messaging.title')}
      </Heading>
      <p
        className={styles.introText}
        dangerouslySetInnerHTML={{
          __html: t('product.pdp.promotion.messaging.intro'),
        }}
      />
      <ul className={styles.unstyledList}>
        {promotionEarningAmounts.map(({ spendAmount, receiveAmount }) => (
          <li key={spendAmount} className={styles.spendMessageItem}>
            {t('product.pdp.promotion.messaging.spend', {
              spendAmount,
              receiveAmount,
            })}
          </li>
        ))}
      </ul>
      {/* <p
        className={styles.outroText}
        dangerouslySetInnerHTML={{
          __html: t('product.pdp.promotion.messaging.outro'),
        }}
      /> */}
      <Button
        href={promotionURL(locale)}
        className={styles.button}
        label={t('product.pdp.promotion.messaging.linkText')}
        size="small"
        variant="unstyled"
      />
    </AlertInlineMessage>
  );
};

export default PromotionMessaging;
